/* ================================================================
   theme-extras.js — 商品ページ・カート用JS
================================================================ */
(function () {
  'use strict';

  /* ── 商品サムネイル切替 ── */
  document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
    const main = section.querySelector('[id^="MainProductImage-"]');
    const thumbs = section.querySelectorAll('.p-product__thumb');

    if (main && thumbs.length > 0) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.src;
          if (!src) return;
          main.src = src;
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
      // 初期状態
      thumbs[0].classList.add('is-active');
    }
  });

  /* ── 商品オプション選択時にバリアントID更新 ── */
  document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const select = section.querySelector(`#ProductVariant-${sectionId}`);
    const optionInputs = section.querySelectorAll('[data-option-index]');

    if (!select || optionInputs.length === 0) return;

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const selectedOptions = [];
        const groups = section.querySelectorAll('.p-product__option');
        groups.forEach((group) => {
          const checked = group.querySelector('input[type="radio"]:checked');
          if (checked) selectedOptions.push(checked.value);
        });

        for (const option of select.options) {
          const variantTitle = option.textContent.trim().split(' - ')[0];
          if (variantTitle === selectedOptions.join(' / ')) {
            option.selected = true;
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    });
  });

  /* ── カート数量変更時の自動更新（任意：今は手動updateボタンで運用） ── */
  // Future enhancement.

})();
